import React, { useEffect, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { Row, Col, Typography, Spin, Flex, Button } from "antd"
import { useTranslation } from "react-i18next"
import { PreviewAddress } from "pagesV2/pro/Experiences/ListingPreview/PreviewAddress"
import { PreviewMediaListing } from "pagesV2/pro/Experiences/ListingPreview/PreviewMedia"
import PreviewAbout from "pagesV2/pro/Experiences/ListingPreview/PreviewAbout"
import { PreviewMeetingLocation } from "pagesV2/pro/Experiences/ListingPreview/PreviewMeetingLocation"
import { PreviewGuide } from "pagesV2/pro/Experiences/ListingPreview/PreviewGuide"
import EmbeddedBookingLayout from "../EmbeddedBookingLayout"
import { routes } from "router"
import { BOOKING_MODES } from "pagesV2/pro/Bookings/constants"
import BookingDetailCard from "../ExperienceBooking/BookingDetailCard"
import { fetchExperienceById } from "store/experiences"
import { getPublicExperienceOptions } from "store/trips"
import styles from "../ExperienceListing/ExperienceListing.module.css"
import PropTypes from "prop-types"
import EmbeddedPageHeader from "../EmbeddedPageHeader"
import { useTheme } from "context/AntdThemeContext"
import { LeftArrow } from "ui/Icon/DSIcon/LeftArrow"
import GuideRatingInfo from "./GuideRatingInfo"

const { Title } = Typography

const EmbeddedExperienceDetail = ({ mode }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const [t] = useTranslation()
  const { uuid, id } = useParams()
  const b_uuid = location.state?.b_uuid
  const { loading, experienceDetail } = useSelector((state) => state?.experiences?.experienceById)
  const { switchTheme } = useTheme()
  const [bookingErrors, setBookingErrors] = useState({
    date: false,
    counts: false,
    tripLength: false,
    timeSlot: false
  })

  useEffect(() => {
    if (id) {
      dispatch(fetchExperienceById(id, b_uuid, mode))
      dispatch(getPublicExperienceOptions(id))
    }
  }, [id, dispatch, b_uuid, mode])

  // Apply theme based on guide's adventure_mode
  useEffect(() => {
    if (experienceDetail?.guide?.adventure_mode) {
      switchTheme(experienceDetail.guide.adventure_mode)
    }
  }, [experienceDetail?.guide?.adventure_mode, switchTheme])
  const navigate = useNavigate()

  return (
    <>
      {!mode && <EmbeddedPageHeader />}
      {loading && (
        <div className={styles.loaderOverlay}>
          <Spin size="large" />
        </div>
      )}
      <EmbeddedBookingLayout type={"experience_detail"} mode={mode}>
        <div>
          <Flex gap={5} align="center" className="pb-xs" style={{ position: "relative", paddingRight: "100px", marginTop: "15px" }}>
            {mode === BOOKING_MODES.embedded && (
              <Button type="text" className={styles.backIcon} onClick={() => navigate(routes.embeddedExperienceListing({ uuid }))}>
                <LeftArrow />
              </Button>
            )}
            <Title level={4} className={styles.experienceTitle}>
              {experienceDetail?.title}
            </Title>
          </Flex>
        </div>
        <Row gutter={[16, 16]} className={`${mode === "embedded" ? styles.embeddedView : ""}`}>
          <Col span={24} lg={16}>
            <Flex justify="space-between" align="end" gap={16} className="flex-wrap">
              <div style={{ flex: "1 1 240px" }}>
                <PreviewAddress embedded trip={experienceDetail} t={t} />
              </div> 
              <div className="ms-auto flex-shrink-0">
                <GuideRatingInfo guide={experienceDetail?.guide} />
              </div>
            </Flex>
            <PreviewMediaListing embedded trip={experienceDetail} />
            <PreviewAbout embedded trip={experienceDetail} t={t} />
            <PreviewMeetingLocation embedded trip={experienceDetail} t={t} />
            <PreviewGuide embedded trip={experienceDetail} t={t} />
          </Col>
          <Col span={24} lg={8}>
            <BookingDetailCard
              bookNow={true}
              trip={experienceDetail}
              bookingButtonVisible={true}
              bookingErrors={bookingErrors}
              setBookingErrors={setBookingErrors}
              mode={mode}
              embedded
            />
          </Col>
        </Row>
      </EmbeddedBookingLayout>
    </>
  )
}

EmbeddedExperienceDetail.propTypes = {
  mode: PropTypes.string
}

export default React.memo(EmbeddedExperienceDetail)
